import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { CreateButton, useListContext } from 'react-admin';
import "../empty.css";


const EmptyMyProductList = () => {
    const { basePath } = useListContext();
    return (
        <>
            <Box textAlign="center" m={1} marginTop={20}>
                <Typography  variant="h4" className="Title">
                    Non hai ancora registrato un prodotto!
                </Typography>
                <br></br>
                <CreateButton basePath={basePath} label="Registra un nuovo prodotto" style={{
                    marginTop: "2%"
                }}/>
            </Box>
        </>
    );
};

export default EmptyMyProductList;